import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BookingCompletedVisitDetails } from '@app/booking-part/models/booking-completed-visit-details.model';
import { PaymentType } from '@app/shared/enums/payment-type.enum';

@Component({
  selector: 'app-booking-completed-summary',
  templateUrl: './booking-completed-summary.component.html',
  styleUrls: ['./booking-completed-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingCompletedSummaryComponent {
  @Input() currentLang: string;
  @Input() visitDetails: BookingCompletedVisitDetails;

  public PaymentType = PaymentType;
}
